import axios from 'axios';

const api = '/api/client-news';

export const getClientNews = params => {
  return axios.get(`${api}/${params}?cacheBuster=${new Date().getTime()}`);
};

export const getLast3 = () => {
  return axios.get(`${api}/last3?cacheBuster=${new Date().getTime()}`);
};

export const createClientNews = (data, file) => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('clientNews', new Blob([JSON.stringify(data)], { type: 'application/json' }));

  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, formData);
};

export const updateClientNews = (id, data, file) => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('clientNews', new Blob([JSON.stringify(data)], { type: 'application/json' }));

  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, formData);
};

export const getClientNewsById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const deleteClientNews = id => {
  return axios.delete(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};
